function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Add User Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.0002,8.5 C19.4262,8.5 19.5002,14.935 19.5002,15 C19.5002,15.276 19.2762,15.5 19.0002,15.5 L19.0002,15.5 L7.0002,15.5 C6.7232,15.5 6.5002,15.276 6.5002,15 C6.5002,14.935 6.5742,8.5 13.0002,8.5 Z M13.0002,9.5 C8.4852,9.5 7.6762,13.137 7.5312,14.5 L7.5312,14.5 L18.4672,14.5 C18.3182,13.137 17.4982,9.5 13.0002,9.5 Z M4,3.5 C4.276,3.5 4.5,3.724 4.5,4 L4.5,4 L4.5,6.5 L7,6.5 C7.276,6.5 7.5,6.724 7.5,7 C7.5,7.276 7.276,7.5 7,7.5 L7,7.5 L4.5,7.5 L4.5,10 C4.5,10.276 4.276,10.5 4,10.5 C3.724,10.5 3.5,10.276 3.5,10 L3.5,10 L3.5,7.5 L1,7.5 C0.724,7.5 0.5,7.276 0.5,7 C0.5,6.724 0.724,6.5 1,6.5 L1,6.5 L3.5,6.5 L3.5,4 C3.5,3.724 3.724,3.5 4,3.5 Z M12.999,0.5 C14.929,0.5 16.499,2.07 16.499,4 C16.499,5.93 14.929,7.5 12.999,7.5 C11.069,7.5 9.499,5.93 9.499,4 C9.499,2.07 11.069,0.5 12.999,0.5 Z M12.999,1.5 C11.621,1.5 10.499,2.622 10.499,4 C10.499,5.378 11.621,6.5 12.999,6.5 C14.377,6.5 15.499,5.378 15.499,4 C15.499,2.622 14.377,1.5 12.999,1.5 Z",
  id: "add-user-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "add-user-Icon/Global/adduser",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "add-user-Swatches/DarkGreen",
  transform: "translate(2.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "add-user-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#add-user-path-1"
})));

var SvgAddUser = function SvgAddUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-user.97a9f53e.svg";
export { ForwardRef as ReactComponent };